import React from 'react';
import PropTypes from 'prop-types';
import './Legend.css';

import HeartIcon from '../HeartIcon';
import SwapIcon from '../SwapIcon';
import CollectionIcon from '../CollectionIcon';

/**
 * Legend component to display icon meanings
 * Using BEM naming convention for CSS classes
 */
const Legend = ({ className = '', showBulk = false }) => {
  return (
    <div className={`legend ${className}`}>
      <div className="legend__container">
        <div className="legend__section">
          <h3 className="legend__title">Icon Legend</h3>
          
          <div className="legend__row">
            <div className="legend__icon">
              <HeartIcon size={24} />
            </div>
            <span className="legend__text">Add to wishlist</span>
          </div>
          
          <div className="legend__row">
            <div className="legend__icon">
              <HeartIcon size={24} isActive />
            </div>
            <span className="legend__text">On wishlist - Click to remove</span>
          </div>
          
          <div className="legend__row">
            <div className="legend__icon">
              <CollectionIcon size={24} />
            </div>
            <span className="legend__text">Not in your collection</span>
          </div>
          
          <div className="legend__row">
            <div className="legend__icon">
              <CollectionIcon size={24} isActive />
            </div>
            <span className="legend__text">In your collection</span>
          </div>

          <div className="legend__row">
            <div className="legend__icon">
              <SwapIcon size={24} />
            </div>
            <span className="legend__text">Not on your Available Cards list</span>
          </div>
          
          <div className="legend__row">
            <div className="legend__icon">
              <SwapIcon size={24} isActive />
            </div>
            <span className="legend__text">On your Available Cards list</span>
          </div>
        </div>
        
        {showBulk && (
          <div className="legend__section">
            <h3 className="legend__title">Bulk Actions (Large Icons)</h3>
            
            <div className="legend__row">
              <div className="legend__icon legend__icon--large">
                <HeartIcon size={40} />
              </div>
              <span className="legend__text">Bulk add to wishlist</span>
            </div>

            <div className="legend__row">
              <div className="legend__icon legend__icon--large">
                <CollectionIcon size={40} />
              </div>
              <span className="legend__text">Bulk add to collection</span>
            </div>

            <div className="legend__row">
              <div className="legend__icon legend__icon--large">
                <SwapIcon size={40} />
              </div>
              <span className="legend__text">Bulk add to Available Cards list</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Legend.propTypes = {
  className: PropTypes.string,
  showBulk: PropTypes.bool
};

export default Legend;